<template>
  <v-dialog
    v-model="active"
    max-width="80%"
    class="nbs"
    :width="options.width"
    :elevation="0"
    :height="options.height + 200"
  >
    <v-app-bar dense color="transparent" flat>
      <v-btn
        class="exit"
        @click="active = false"
        elevation="0"
        fab
        width="25"
        height="25"
      >
        <Tooltip content="Close" top color="red">
          <v-icon size="25">mdi-close-circle</v-icon>
        </Tooltip>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        @click="download"
        color="light-green"
        elevation="0"
        dark
        top
        right
        width="150"
        small
      >
        <Tooltip content="Download the file" top color="light-green">
          Download
          <v-icon class="ml-2">mdi-cloud-download</v-icon>
        </Tooltip>
      </v-btn>
    </v-app-bar>
    <v-carousel
      :max-height="options.height"
      :height="options.height"
      hide-delimiter-background
      :continuous="options.continuous"
      :cycle="options.cycle"
      :progress="options.cycle"
      :show-arrows="slides.length > 1"
      show-arrows-on-hover
      :hide-delimiters="!options.delimiters || slides.length <= 1"
      v-model="current"
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <v-sheet class="scrollable fill-height">
          <!-- <v-row class="fill-height" align="center" justify="center">
            <div class=" scrollable h40"> -->
          <VideoPlayer v-if="isVideo(slide)" :src="slide" autoplay />
          <v-img v-else contain centered :src="slide"> </v-img>
          <!-- </div>
          </v-row> -->
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>

<script lang="ts">
import { v4 } from "uuid";
import Vue from "vue";
import Tooltip from "@/components/Tooltip.vue";
import VideoPlayer from "../VideoPlayer.vue";

export default Vue.extend({
  name: "SliderDialog",
  data() {
    return {
      videoFormats: {
        ogg: 'video/ogg; codecs="theora"',
        h264: 'video/mp4; codecs="avc1.42E01E"',
        webm: 'video/webm; codecs="vp8, vorbis"',
        vp9: 'video/webm; codecs="vp9"',
        hls: 'application/x-mpegURL; codecs="avc1.42E01E"',
      },
      current: "",
    };
  },
  components: { Tooltip, VideoPlayer },
  computed: {
    slides(): string[] {
      return this.$store.getters.getSlides;
    },
    currentSlide(): string {
      return this.slides[this.current];
    },
    active: {
      get(): boolean {
        return this.slides.length > 0;
      },
      set(val: boolean) {
        if (!val) {
          this.$store.commit("setSlides");
        }
      },
    },
    options(): any {
      return this.$store.getters.getSlidesOptions;
    },
  },
  methods: {
    isVideo(src: string) {
      const re = /(?:\.([^.]+))?$/;
      const fileExt = re.exec(src);
      const isVideo = Object.keys(this.videoFormats).includes(fileExt[1]); // this.supportsVideoType(fileExt[1]);
      return isVideo;
    },
    // active check for video support
    supportsVideoType(type) {
      let video;
      if (!video) {
        video = document.createElement("video");
      }
      const probebly =
        video.canPlayType(this.videoFormats[type] || type) === "probably";
      video.remove();
      return probebly;
    },
    download() {
      const urlObj = window.URL.createObjectURL(new Blob([this.currentSlide]));
      const link = document.createElement("a");
      link.href = this.currentSlide;
      link.setAttribute("download", `${v4()}.jpg`); //or any other extension
      document.body.appendChild(link);
      link.click();
      console.log("downloading", urlObj);
    },
  },
});
</script>
<style scoped>
.nbs {
  box-shadow: none !important;
}
.download {
  top: -15px !important;
  z-index: 9999 !important;
}
</style>
